// Requires window.loadExternalFile function to be defined.
const TippyHook = {
  mounted() {
    this.run("mounted", this.el);
  },
  updated() {
    this.run("updated", this.el);
  },
  run(lifecycleMethod, el) {
    loadExternalFile([
      "https://cdnjs.cloudflare.com/ajax/libs/tippy.js/6.3.7/tippy.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/popper.js/2.11.5/umd/popper.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/tippy.js/6.3.7/tippy.umd.min.js",
    ]).then(() => {
      const tippyInstance = tippy(el);
      const disableOnMount = el.dataset.disableTippyOnMount === "true";

      if (lifecycleMethod === "mounted" && disableOnMount) {
        tippyInstance.disable();
      }
    });
  },
};

export default TippyHook;
